import { ProgressReportPreviewInterface } from '@/src/models/IProgress';
import { Button, Table, Tag } from 'antd';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

export function StaffCompletionReport(){
    const navigate = useNavigate();

    const [ReportList,setReportList] = useState<ProgressReportPreviewInterface[]>([])
    
    const getData = async() =>{
        axios.get(`${process.env.REACT_APP_BASE}/GetCompletedReport/${sessionStorage.getItem('PositionName')}`).then(response=>{
            if(response.status==200){
                setReportList(response.data)
            }
        })
    }

    useEffect(()=>{
        getData();
    },[]);
    
    return (<>
        <h1 className="text-3xl font-semibold ">คำขอปิดโครงการ</h1>
        <br/>
        <hr/>
        <br/>
        <Table columns={[
            {
                title:'ชื่อโครงการ',
                dataIndex:'project_name_th'
            },{
                title:'ผู้ยื่นความก้าวหน้า',
                dataIndex:'head_name_th'
            },{
                title:'สถานะรายงานความก้าวหน้า',
                dataIndex:'ReportStatus',
                render: (ReportStatus:string)=>
                {
                    let color = 'purple'
                    if(sessionStorage.getItem("PositionName")=="เจ้าหน้าที่"){
                        switch(ReportStatus){
                            case 'รอการพิจารณาจากเจ้าหน้าที่วิจัย' : 
                                color = "blue";
                                break;
                            case 'รอการพิจารณาจากผู้อำนวยการสำนักวิจัย':
                            case 'รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                color = "purple";
                                break;
                            case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                            case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                            case 'สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                color = "yellow";
                                break;
                            case 'อนุมัติ':
                                color = "green";
                                break;
                        }
                    }else if(sessionStorage.getItem("PositionName")=="ผู้อำนวยการสำนักวิจัยและบริการวิชาการ"){
                        switch(ReportStatus){
                            case 'รอการพิจารณาจากผู้อำนวยการสำนักวิจัย' : 
                                color = "blue";
                                break;
                          
                            case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                            case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                            case 'สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                color = "yellow";
                                break;
                            case 'อนุมัติ':
                                color = "green";
                                break;
                        }
                    }else if(sessionStorage.getItem("PositionName")=="รองอธิการบดีฝ่ายวิจัยและบริการวิชาการ"){
                        switch(ReportStatus){
                            case 'รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ' : 
                                color = "blue";
                                break;
                          
                            case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                            case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                            case 'สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                color = "yellow";
                                break;
                            case 'อนุมัติ':
                                color = "green";
                                break;
                        }
                    }


                    return <Tag color={color}>{ReportStatus}</Tag>;
                }
            },{
                title:'วันเวลาที่ยื่นรายงานความก้าวหน้า',
                dataIndex:'SentBy',
                render:(_,record,index)=>(
                    <><p>{moment.utc(record.SentBy).format("DD/MM/YYYY HH:mm:ss")}</p></>
                )
            },{
                dataIndex:'action',
                render:(_,record,index)=>(
                    <><Button onClick={()=>{
                        sessionStorage.setItem('head_user', record.head_researcher);
                        sessionStorage.setItem('project_id', record.budgetreq_id);
                        navigate(`/VRIIS/CompletionReportReview/${record.ProgressReportID}`)
                    }
                }>ดู</Button></>
                )
            }
        ]}
        dataSource={ReportList}/>
        
    </>)
}